import styled from "styled-components";

const TOPIC_COLUMN_STICKY_BREAKPOINT = 1280;

export const StickyTopicColumnWrapper = styled.div`
    @media (max-width: ${TOPIC_COLUMN_STICKY_BREAKPOINT - 1}px) {
        & .ant-table-cell-fix-left {
            position: static;
            left: auto !important;
        }

        & .ant-table-cell-fix-left-last {
            box-shadow: none;
        }
    }
`;
